import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'crab',
      d: 'M-3,-3h1v0.5h-1zM2,-3h1v0.5h-1zM-3.5,-2.5h2v0.5h-2zM1.5,-2.5h2v0.5h-2zM-3.5,-2h7v0.5h-7zM-2,-1.5h4v0.5h-4zM-2.5,-1h5v0.5h-5zM-3,-0.5h6v0.5h-6zM-3,0h0.5v0.5h-0.5zM-2,0h4v0.5h-4zM2.5,0h0.5v0.5h-0.5zM-2,0.5h1.5v0.5h-1.5zM0.5,0.5h1.5v0.5h-1.5z',
    },
    { paint: 'shadow', d: 'M-1,-2.5h2v0.5h-2z' },
  ],
  pixels: 76,
};
export const sprites: readonly PixelSprite[] = [variant0, variant0, variant0];
